import React from "react";
import { getOmpSearchString } from "@src/api/main/OMPTypes";
import { labouringApi, type ApiLabouring, type ApiLabouringFilter } from "@src/api/dictionaries/labouring";
import { formatFullNameLabouring } from "@src/helpers/business/labouring/formatFullNameLabouring";
import { BusinessSearchSelect, type BusinessSearchSelectProps } from "../BusinessSearchSelect";
import { PickerOptionCard } from "@src/shared/ui";

export type LabouringSearchSelectProps = Omit<
    BusinessSearchSelectProps<ApiLabouring, number>,
    "queryKeyBase" | "loadOptions" | "loadById" | "getId" | "getOptionLabel" | "getSelectedLabel"
> & {
    /** Доп. фильтр API (например `Out: false`). */
    flt?: ApiLabouringFilter;
};

/**
 * SearchSelect для справочника работников ({@link ApiLabouring}).
 */
export function LabouringSearchSelect({
    label = "Работник",
    flt,
    minSearchLength = 2,
    debounceDelay = 500,
    searchPlaceholder = "ФИО, штамп или таб. номер",
    value,
    onChange,
    optionSlots,
    ...rest
}: LabouringSearchSelectProps) {
    return (
        <BusinessSearchSelect<ApiLabouring, number>
            queryKeyBase={["searchSelect", "labouring", flt]}
            loadOptions={async (query) => {
                const result = await labouringApi.load({
                    flt: {
                        ...flt,
                        FullName: getOmpSearchString(query, { fullTextSearch: true }),
                    },
                });
                return result.items ?? [];
            }}
            loadById={async (code) => {
                const result = await labouringApi.load({
                    flt: { ...flt, Codes: [code] },
                    limit: 1,
                    offset: 0,
                });
                return result.items?.[0] ?? null;
            }}
            getId={(item) => item.Code}
            getOptionLabel={(item) => formatFullNameLabouring(item, "Sf N. P.")}
            getSelectedLabel={(item) => formatFullNameLabouring(item, "Sf N. P.")}
            value={value}
            onChange={onChange}
            label={label}
            searchPlaceholder={searchPlaceholder}
            minSearchLength={minSearchLength}
            debounceDelay={debounceDelay}
            {...rest}
            optionSlots={{
                ...optionSlots,
                fullscreen:
                    optionSlots?.fullscreen ??
                    ((item) => {
                        return (
                            <PickerOptionCard
                                title={`Работник ${formatFullNameLabouring(item, "Sf N. P.")}`}
                                details={[
                                    { label: "Штамп", value: item.Stamp },
                                    // { label: "Id", value: item.Id },
                                ]}
                            />
                        );
                    }),
            }}
        />
    );
}
